module.exports = __webpack_public_path__ + "img/shape2.d1df8e48.png";